module.exports = __webpack_public_path__ + "static/media/รายงานการดำเนินคดีของลูกหนี้.3f0295ba.xls";